import React, { useState } from 'react';
import * as firebase from 'firebase';
import PubSub from 'pubsub-js'
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export default function DropDown(props) {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  var userLoggedOwnerComment = false

  function deleteComment(e) {
    setAnchorEl(null);
    console.log("Deleting comment")
    console.log(`/User-Likes-And-Comments/Comments/${props.userIdWithComment}/${props.idComment}`)
    const commentRef = firebase.database().ref(`/User-Likes-And-Comments/Comments/${props.userIdWithComment}/${props.idComment}`);
    commentRef.remove()
    var friendUser = props.friendUser
    console.log(friendUser)
    friendUser.qtComments--;
    console.log(friendUser)
    firebase.database().ref('usuarios/' + friendUser.id).set(friendUser)
    PubSub.publish('Update-Comments', true);
    PubSub.publish('Deleted-Comment', true);
  }

  function editComment(e) {
    setAnchorEl(null);
    console.log("Editing comment")
    console.log(props.userIdWithComment)
    console.log(props.idComment)
    PubSub.publish('Edit-Comment', props.idComment);
  }

  function reportComment(e) {
    setAnchorEl(null);
    console.log("Reporting comment")
    PubSub.publish('Report-Comment', props.idComment);
  }

  const ITEM_HEIGHT = 38;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = event => {
    console.log(event.key)
    setAnchorEl(null);
  };

  if (props.idUser == localStorage.getItem("userId")) {
    userLoggedOwnerComment = true
  }

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: 200,
          },
        }}
      >
        {userLoggedOwnerComment && (<MenuItem onClick={editComment}>Editar</MenuItem>)}
        {userLoggedOwnerComment && (<MenuItem onClick={deleteComment}>Deletar</MenuItem>)}
        {!userLoggedOwnerComment && (<MenuItem onClick={reportComment}>Reportar</MenuItem>)}
      </Menu>
    </div>
  )
}